import { render, staticRenderFns } from "./CPDueDiligenceAccountHolderTaxDetails.vue?vue&type=template&id=3423a0c6&scoped=true&"
import script from "./CPDueDiligenceAccountHolderTaxDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceAccountHolderTaxDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceAccountHolderTaxDetails.vue?vue&type=style&index=0&id=3423a0c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423a0c6",
  null
  
)

export default component.exports